import React from 'react';

interface TimeSlotProps {
  dayIndex: number;
  timeIndex: number;
  isHighlighted: boolean;
  onMouseDown: (event: React.MouseEvent, dayIndex: number, timeIndex: number) => void;
  onMouseEnter: (dayIndex: number, timeIndex: number) => void;
  onMouseUp: () => void;
}

const TimeSlot: React.FC<TimeSlotProps> = ({
  dayIndex,
  timeIndex,
  isHighlighted,
  onMouseDown,
  onMouseEnter,
  onMouseUp,
}) => {
  return (
    <div
      className={`h-6 border-b border-clinic-primary-lighter/50 cursor-pointer transition-colors select-none ${
        isHighlighted
          ? 'bg-clinic-primary/20 border-clinic-primary/30'
          : 'hover:bg-clinic-cream/50'
      }`}
      onMouseDown={(e) => onMouseDown(e, dayIndex, timeIndex)}
      onMouseEnter={() => onMouseEnter(dayIndex, timeIndex)}
      onMouseUp={onMouseUp}
      data-testid={`time-slot-${dayIndex}-${timeIndex}`}
    />
  );
};

export default React.memo(TimeSlot);